import BlCellMv from './BlCellMv.vue'

BlCellMv.install = function(Vue) {
  Vue.component(BlCellMv.name, BlCellMv)
}

export default BlCellMv
